import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import {
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00037-electrolyseur-statut',
  templateUrl: './p00037-electrolyseur-statut.component.html',
  styleUrls: ['./p00037-electrolyseur-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
    TranslatePipe,
    CollapseComponent,
    IonItem,
    IonLabel,
    IonList,
  ],
})
export class P00037ElectrolyseurStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  editValue(index: any, key: string, value: any): void {
    this.actionStack!.editValue(index, key, value);
  }

  commit(): void {
    this.actionStack!.commit();
  }

  resetNiveauSel(): void {
    this.editValue(P00039DataRxTxIndex.SALT_Controle, 'elCResetNiveauSel', 1);
    this.commit();
  }

  resetProtectionPresenceGaz(): void {
    this.editValue(
      P00039DataRxTxIndex.SALT_Controle,
      'elCResetProtectionPresenceGaz',
      1,
    );
    this.commit();
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  getPolariteLabel(value: number): string {
    switch (value) {
      case 2:
        return '-';
      case 1:
        return '+';
      default:
        return this.translateService.instant('P00037.status.enCours');
    }
  }

  getCaracteristiqueCelluleLabel(value: number): string {
    switch (value) {
      case 1:
        return this.translateService.instant(
          'P00037.status.caraccelluleutilise.memoire',
        );
      case 2:
        return this.translateService.instant(
          'P00037.status.caraccelluleutilise.qrcode',
        );
      default:
        return '-';
    }
  }

  getResultatTestCelluleLabel(value: number): string {
    switch (value) {
      case 3:
        return this.translateService.instant(
          'P00037.status.resulttestcellule.3',
        );
      case 2:
        return this.translateService.instant(
          'P00037.status.resulttestcellule.2',
        );
      case 1:
        return this.translateService.instant(
          'P00037.status.resulttestcellule.1',
        );
      default:
        return '-';
    }
  }

  getEtatProductionLabel(value: number): string {
    switch (value) {
      case 2:
        return this.translateService.instant('P00037.status.inversion');
      case 1:
        return this.translateService.instant('P00037.status.production');
      default:
        return '';
    }
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
